
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Actempotraveller() {



    const cardData =
    {
        keyword: ' Ac Tempo Traveller Rent Pune',
        heading: 'Samarth Travels: Ac Tempo Traveller Rent Pune',
        headingDescription: 'Samarth Travels offers reliable and affordable AC Tempo Traveller rentals in Pune, ideal for group outings, corporate events, or family trips. Choose from a range of well-maintained air-conditioned vehicles, including 12-seater and 13-seater options, all equipped with comfortable seating and essential amenities. With transparent pricing, no hidden charges, and a commitment to punctuality and customer satisfaction, Samarth Travels ensures a smooth and enjoyable travel experience across Pune and beyond.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

        "topPlaces": [
             {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada is one of Pune's most iconic landmarks and a symbol of the Maratha Empire. Built in 1732 as the seat of the Peshwas, this grand fortification features majestic gates, elegant fountains, and intricate architecture. Although much of it was destroyed by fire in 1828, its massive stone walls and legendary tales—especially those surrounding the ghost of Narayanrao—still attract thousands of history lovers and tourists each year."
            },
            {
                "title": "Aga Khan Palace",
                "description": "The Aga Khan Palace is a stunning historical monument built in 1892 by Sultan Aga Khan III. It holds immense national significance due to its association with Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters who were imprisoned here during the Quit India Movement. Set in lush green gardens, the palace showcases Italian arches and spacious halls and also houses a museum with photographs, paintings, and personal belongings of Gandhi, making it a must-visit for those interested in India’s independence movement."
            },
            {
                "title": "Sinhagad Fort",
                "description": "Perched atop the Sahyadri hills, Sinhagad Fort is a historic hill fortress located about 30 kilometers from Pune. Famous for the Battle of Sinhagad in 1670, where Maratha warrior Tanaji Malusare fought valiantly, the fort offers breathtaking views, trekking trails, and remnants of ancient military architecture including bastions, gates, and memorials. It's an ideal destination for trekking enthusiasts, history buffs, and nature lovers alike."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "The Pataleshwar Cave Temple is a unique 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single massive basalt rock, this ancient temple is a fine example of monolithic architecture from the Rashtrakuta period. Its main sanctum houses a linga, and the surrounding sanctum sanctorum includes statues of other deities. Despite being in the middle of the bustling city, it offers a tranquil and spiritual atmosphere for visitors."
            }, 
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "This revered Ganesh temple is one of the most visited and richly adorned temples in Maharashtra. Established by a sweet-maker named Dagdusheth Halwai in the late 19th century, the temple is known for its magnificent idol of Lord Ganesh decked in gold and diamonds. The temple draws massive crowds during the Ganesh Chaturthi festival, and its serene ambiance makes it a spiritual haven throughout the year."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This museum is a treasure trove of Indian heritage and folk art, established by Dr. Dinkar Kelkar in memory of his son. It houses over 20,000 rare and artistic artifacts, including musical instruments, sculptures, paintings, utensils, weaponry, and textiles from all over India. The collection gives a vivid picture of everyday life in bygone eras and is especially appealing to art enthusiasts and cultural historians."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Rising 2,100 feet above sea level, Parvati Hill offers panoramic views of Pune city. The hilltop temple complex consists of five main temples, including the Devdeveshwar temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa rule, it is not only a religious site but also a peaceful escape from the city buzz. A climb of 103 stone steps leads to the summit, where history and nature meet."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in the serene Koregaon Park area, the Osho International Meditation Resort is a tranquil oasis for seekers of inner peace and mindfulness. Founded by the spiritual guru Osho, it offers daily meditation sessions, yoga programs, and various wellness therapies in a luxurious, Zen-like environment. Visitors from all over the world come here for spiritual growth, rejuvenation, and to experience the calm ambiance of its lush gardens and modern facilities."
            },
            {
                "title": "Pune Okayama Friendship Garden",
                "description": "Also known as Pu La Deshpande Garden, this beautifully landscaped garden is inspired by Japan’s Okayama Korakuen Garden. Spread over 10 acres, it features artistically arranged lawns, water bodies, bridges, and pathways that create a harmonious blend of nature and design. It's a favorite among photography enthusiasts, families, and couples seeking a peaceful retreat amid nature."
            },
            {
                "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
                "description": "This combined facility includes a zoo, snake park, and a wildlife rescue center. The snake park is known for its wide variety of snakes, including the King Cobra and Indian Python, as well as informative exhibits on reptile behavior and conservation. The adjoining zoo is home to tigers, leopards, elephants, and other animals, making it an engaging educational and recreational spot, especially for children and families."
            }
        ],

"services": [
    {
        "name": "AC Tempo Traveller Hire in Pune",
        "description": "Experience cool and comfortable travel with Samarth Travels’ AC Tempo Traveller hire service in Pune. Ideal for families, corporate groups, and tourists, our vehicles are equipped with powerful air conditioning, clean interiors, and professional drivers to ensure a smooth journey every time."
    },
    {
        "name": "Affordable AC Tempo Traveller Rent Pune",
        "description": "Looking for cost-effective AC Tempo Traveller rentals in Pune? Samarth Travels offers budget-friendly rates with top-notch service. Enjoy a relaxing ride with chilled air conditioning, spacious seating, and competitive pricing for local and outstation travel."
    },
    {
        "name": "AC Tempo Traveller for Group Travel in Pune",
        "description": "Planning a group outing? Rent an AC Tempo Traveller from Samarth Travels in Pune for a comfortable and hassle-free group travel experience. With seating options from 12 to 17 passengers, our vehicles are perfect for friends, families, or office teams traveling together."
    },
    {
        "name": "Luxury AC Tempo Traveller Hire Pune",
        "description": "Upgrade your travel with our luxury AC Tempo Traveller hire in Pune. Featuring reclining seats, ample legroom, ambient lighting, and efficient climate control, Samarth Travels ensures a premium experience whether you’re heading for a business trip, wedding, or holiday."
    },
    {
        "name": "Rent AC Tempo Traveller for Family Trips in Pune",
        "description": "Make your family trips more enjoyable by renting an AC Tempo Traveller in Pune. Samarth Travels provides safe and comfortable vehicles ideal for family vacations, temple visits, or weekend getaways, with enough room for luggage and relaxation throughout the ride."
    },
    {
        "name": "AC Tempo Traveller Rental Services in Pune",
        "description": "Samarth Travels offers dependable AC Tempo Traveller rental services across Pune for local and long-distance travel. Whether it’s sightseeing, weddings, corporate events, or airport transfers, our modern fleet ensures a smooth ride with cool air and courteous drivers."
    },
    {
        "name": "12-Seater AC Tempo Traveller Rent Pune",
        "description": "For small group travel, rent a 12-seater AC Tempo Traveller in Pune from Samarth Travels. Perfect for family tours, corporate groups, or short outings, this vehicle offers just the right balance of comfort, capacity, and affordability."
    },
    {
        "name": "16-Seater AC Tempo Traveller Rental in Pune",
        "description": "Need a bigger vehicle for your travel group? Choose Samarth Travels’ 16-seater AC Tempo Traveller in Pune. Ideal for school tours, company outings, or extended family trips, it combines space, ventilation, and reliability in one complete travel package."
    },
    {
        "name": "AC Tempo Traveller for Corporate Events in Pune",
        "description": "Ensure professional and punctual transportation for your team with our AC Tempo Traveller hire for corporate events in Pune. Samarth Travels provides well-maintained vehicles with AC comfort, suited for seminars, offsite meetings, and business tours."
    },
    {
        "name": "Hire AC Tempo Traveller for Wedding in Pune",
        "description": "Make wedding travel seamless and comfortable by hiring an AC Tempo Traveller from Samarth Travels in Pune. Perfect for guest transfers and family travel between venues, our AC vehicles ensure everyone arrives cool, relaxed, and on time."
    },
    {
        "name": "AC Tempo Traveller for Pune Sightseeing",
        "description": "Explore Pune’s landmarks in comfort with an AC Tempo Traveller from Samarth Travels. Whether you're visiting historical sites, temples, or scenic destinations, our vehicles provide a cool, pleasant ride for sightseeing groups of all sizes."
    },
    {
        "name": "Rent an AC Tempo Traveller for Outstation Trips",
        "description": "Heading to Lonavala, Shirdi, Mahabaleshwar, or Goa? Rent an AC Tempo Traveller from Samarth Travels for outstation trips from Pune. Enjoy air-conditioned comfort throughout your journey with plenty of space, reliable service, and skilled drivers."
    }
],
"tableData": [
    ["AC Tempo Traveller Hire in Pune", "Affordable AC Tempo Traveller Rent Pune"],
    ["AC Tempo Traveller for Group Travel in Pune", "Luxury AC Tempo Traveller Hire Pune"],
    ["Rent AC Tempo Traveller for Family Trips in Pune", "AC Tempo Traveller Rental Services in Pune"],
    ["12-Seater AC Tempo Traveller Rent Pune", "16-Seater AC Tempo Traveller Rental in Pune"],
    ["AC Tempo Traveller for Corporate Events in Pune", "Hire AC Tempo Traveller for Wedding in Pune"],
    ["AC Tempo Traveller for Pune Sightseeing", "Rent an AC Tempo Traveller for Outstation Trips"]
],


"whychoose": [
    {
        "WhyChooseheading": "Premium AC Tempo Traveller Rent in Pune",
        "WhyChoosedescription": "Samarth Travels offers reliable and comfortable AC Tempo Traveller rental services in Pune, perfect for group travel. Whether you're planning a family trip, corporate outing, or a group tour, our well-maintained air-conditioned Tempo Travellers provide a smooth, comfortable, and enjoyable travel experience for your group."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable AC Tempo Travellers",
        "WhyChoosedescription": "Our fleet of AC Tempo Travellers is designed with your comfort in mind. With seating options ranging from 9 to 26 seats, each vehicle is equipped with air conditioning, ample legroom, and push-back seats for a relaxing journey. Whether it’s a short trip within Pune or a long-distance journey, you’ll experience a comfortable ride every time."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Safe and Timely Travel",
        "WhyChoosedescription": "Our drivers are highly experienced, professional, and well-acquainted with the best routes in Pune and surrounding areas. They prioritize safety, punctuality, and comfort, ensuring that you arrive at your destination on time and in the safest possible manner. They are friendly, courteous, and provide excellent service throughout your journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for AC Tempo Traveller Rentals",
        "WhyChoosedescription": "At Samarth Travels, we offer competitive and transparent pricing for AC Tempo Traveller rentals in Pune. Our rates are clear, with no hidden charges or extra fees, allowing you to plan your trip without worrying about unexpected costs. Whether you need a vehicle for a day trip or a longer journey, we provide great value for your money."
    },
    {
        "WhyChooseheading": "Available 24/7 to Suit Your Travel Schedule",
        "WhyChoosedescription": "We offer flexible 24/7 availability for AC Tempo Traveller rentals in Pune. Whether it’s an early morning departure, a late-night return, or a last-minute booking, Samarth Travels ensures that you get a vehicle when you need it, accommodating your travel schedule no matter the time of day."
    },
    {
        "WhyChooseheading": "Convenient Booking with Real-Time Updates",
        "WhyChoosedescription": "Booking an AC Tempo Traveller with Samarth Travels is simple and hassle-free. You can book directly through our website or by calling our customer support team. After booking, we provide real-time updates, including live tracking, driver details, and estimated arrival times, keeping you informed throughout your journey."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "We take cleanliness and hygiene seriously. All our AC Tempo Travellers are thoroughly sanitized before and after every trip, ensuring a safe and hygienic environment for passengers. Our vehicles are regularly inspected and maintained to ensure that they are in top condition, offering you a smooth and worry-free journey."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Convenience",
        "WhyChoosedescription": "Samarth Travels offers a variety of payment methods for your convenience, including cash, UPI, credit/debit cards, and digital wallets. You can choose the option that works best for you, ensuring a seamless and secure transaction during your AC Tempo Traveller rental process."
    }
]




















    }

const faqData = [
    {
        id: 1,
        question: 'How do I rent an AC Tempo Traveller in Pune with Samarth Travels?',
        answer: 'Renting an AC Tempo Traveller in Pune with Samarth Travels is easy. Just visit our website or call our customer service team. Provide your travel details such as destination, group size, and dates, and we’ll recommend the best AC Tempo Traveller for your trip.',
    },
    {
        id: 2,
        question: 'What seating options are available for AC Tempo Travellers in Pune?',
        answer: 'Samarth Travels offers AC Tempo Travellers in multiple seating capacities including 9-seater, 12-seater, 17-seater, and 20-seater. All vehicles are ideal for group outings, airport transfers, pilgrimages, or long-distance travel.',
    },
    {
        id: 3,
        question: 'What is included in the AC Tempo Traveller rental price?',
        answer: 'The rental price includes the air-conditioned Tempo Traveller, driver, and fuel charges. We are transparent about all costs, and any tolls, parking fees, or permits will be shared in advance.',
    },
    {
        id: 4,
        question: 'Can I book an AC Tempo Traveller for outstation travel from Pune?',
        answer: 'Yes, Samarth Travels offers AC Tempo Travellers for both local and outstation travel. Whether it’s a hill station like Mahabaleshwar or a beach trip to Alibaug, our AC vehicles provide a comfortable ride throughout.',
    },
    {
        id: 5,
        question: 'Is one-day rental available for AC Tempo Travellers in Pune?',
        answer: 'Absolutely! We offer AC Tempo Traveller rentals for one-day trips, including weddings, corporate events, local sightseeing, or airport transfers. Our booking options are flexible to suit your travel plans.',
    },
    {
        id: 6,
        question: 'Are the AC Tempo Travellers suitable for long trips?',
        answer: 'Yes, our AC Tempo Travellers are perfect for long journeys. They come with comfortable pushback seats, ample luggage space, clean interiors, and strong air-conditioning to ensure a smooth ride.',
    },
    {
        id: 7,
        question: 'Do you offer 24/7 AC Tempo Traveller rental in Pune?',
        answer: 'Yes, we provide 24/7 service for AC Tempo Traveller rentals in Pune. You can schedule pickups or drop-offs at any hour to match your convenience.',
    },
];

const testimonials = [
    {
        name: 'Mr. Kunal Jadhav',
        role: 'Sales Executive',
        text: 'I booked an AC Tempo Traveller from Samarth Travels for a team outing to Lavasa. The vehicle was super clean, cool, and comfortable. Great service and polite driver!',
        image: '/img/testimonial/testi_2_26.jpg',
    },
    {
        name: 'Ms. Pooja Nair',
        role: 'Freelance Photographer',
        text: 'Rented a 12-seater AC Tempo Traveller for a photography trip around Pune. The AC worked great throughout, and the ride was very comfortable. Will book again!',
        image: '/img/testimonial/testi_2_27.jpg',
    },
];



















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC Tempo Traveller Rent Pune",
  "image": "https://samarthtravels.com/assets/images/ac-tempo-traveller-rent-pune.jpg",
  "description": "Rent an AC Tempo Traveller in Pune for group travel, family trips, corporate events, weddings, and sightseeing. Affordable and luxury AC Tempo Traveller rental services available, including 12-seater and 16-seater options for outstation trips and local tours.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/ac-tempo-traveller-rent-pune"
  }
};





    return (
        <div>


<Helmet>
  <title>AC Tempo Traveller Rent in Pune | Group Travel, Weddings & Family Trips | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent an AC Tempo Traveller in Pune for group travel, family trips, corporate events, weddings, and sightseeing. Affordable 12-seater and 16-seater AC Tempo Traveller rental services for outstation trips and local tours with Samarth Travels." 
  />
  <meta 
    name="keywords" 
    content="AC Tempo Traveller Hire in Pune, Affordable AC Tempo Traveller Rent Pune, AC Tempo Traveller for Group Travel in Pune, Luxury AC Tempo Traveller Hire Pune, Rent AC Tempo Traveller for Family Trips in Pune, AC Tempo Traveller Rental Services in Pune, 12-Seater AC Tempo Traveller Rent Pune, 16-Seater AC Tempo Traveller Rental in Pune, AC Tempo Traveller for Corporate Events in Pune, Hire AC Tempo Traveller for Wedding in Pune, AC Tempo Traveller for Pune Sightseeing, Rent an AC Tempo Traveller for Outstation Trips" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/13.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Actempotraveller;